export default {
  font: {
    color: {
      primary: '#004E27',
      secondary: '#fff',
    },
  },
};
